import React from "react";
import config from '../../config'
import { isInDate, DatesSmall } from '../enrolmentform/formelements'

const ModalContent = ({families}) => {

const customOrder = ["ESO", "BATX", "CFGM", "CFGS", "CE", "MONOGRAFICS", "FPB","PFI","IFE"];

  return (
    <>

        <div className="container">
          <div className="row">
            <div className="col col-12 " style={{ backgroundColor: '#333', padding: '2px 0 0 15px' }}>
                <img src={config.headerLogo} alt={'Logo ' + config.headerTitle } style={{ margin: '0px' }} />
            </div>
          </div>
        </div>

<div className="ModalContentTable">



{ families && Object.entries(families).sort(([keyA], [keyB]) => { return customOrder.indexOf(keyA) - customOrder.indexOf(keyB); }).map(([key, f]) => (
        <div key={key}>
          <h3>{key}</h3>
          <table border="0">
            <tbody>
                <tr>
                  <td>Alumnes nous</td><td><DatesSmall dates={f.datesMatricula[0]} class={!isInDate(f.datesMatricula[0]) ? "DateOK" :"DateKO"}/> </td>
                </tr>
                <tr>
                  <td>Alumnes del centre</td><td><DatesSmall dates={f.datesMatricula[1]} class={!isInDate(f.datesMatricula[1]) ? "DateOK" :"DateKO"}/> </td>
                </tr>
            </tbody>
          </table>
        </div>
      )
    )
}
</div>

    <br/>

    <p>
    Les dates marcades en <span className="DateOK">verd</span> indica que estan en obertes per matrícular.
    <br/>
    Les dates marcades en <span className="DateKO">vermell</span> indica que estan actualment tancades.
    </p>
    </>
  )
}

export default ModalContent;